/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Backup from "@material-ui/icons/Backup";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";

// core components
import styles from "assets/jss/material-dashboard-react/components/tableStyle.js";
import { blue, red } from "@material-ui/core/colors";

const useStyles = makeStyles(styles);

export default function CustomTable(props) {
  const classes = useStyles();
  const { tableHead, tableData, tableHeaderColor } = props;

  const handleOpen = (e, name, id) => {
    onOpen(name, id);
  };

  function onOpen(name, id) {
    props.isOpen(true);
    props.name(name);
    props.reportId(id);
  }

  const handleCellClick = (name, id) => {
    onOpen(name, id);
    const fetchData = async () => {

      //   method: "GET"
      // });
      // const data = await response.json();
    };
    fetchData();
  };

  return (
    <div className={classes.tableResponsive}>
      <Table className={classes.table}>
        {tableHead !== undefined ? (
          <TableHead className={classes[tableHeaderColor + "TableHeader"]}>
            <TableRow className={classes.tableHeadRow}>
              {tableHead.map((prop, key) => {
                return (
                  <TableCell
                    style={{ textAlign: "center" }}
                    className={classes.tableCell + " " + classes.tableHeadCell}
                    key={key}
                  >
                    <GridContainer>
                      <GridItem xs={10} sm={10} md={10}>
                        {prop}
                      </GridItem>
                    </GridContainer>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>
        ) : null}
        <TableBody>
          {tableData.slice().map((prop, key1) => {
            return (
              <TableRow
                key={key1}
                className={classes.tableBodyRow}
                style={{ cursor: "pointer" }}
                selected={true}
                hover={true}
                role="checkbox"
              >
                {tableData[key1][4] !== undefined
                  ? prop.slice(0, 3).map((prop, key) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          key={key}
                          style={{ textAlign: "center" }}
                        ></TableCell>
                      );
                    })
                  : prop.slice(0, 1).map((prop, key) => {
                      return (
                        <TableCell
                          className={classes.tableCell}
                          key={key}
                          style={{ textAlign: "center" }}
                          onClick={event =>
                            handleOpen(
                              event,
                              tableData[key1][0],
                              tableData[key1][2]
                            )
                          }
                        >
                          <GridContainer>
                            <GridItem xs={10} sm={10} md={10}>
                              {prop}
                            </GridItem>
                            <GridItem xs={2} sm={2} md={2}>
                              <Backup
                                style={{
                                  color: blue[500],
                                  fontSize: 30,
                                  cursor: "pointer"
                                }}
                                onClick={() =>
                                  handleCellClick(
                                    tableData[key1][0],
                                    tableData[key1][2]
                                  )
                                }
                              ></Backup>
                            </GridItem>
                          </GridContainer>
                        </TableCell>
                      );
                    })}
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </div>
  );
}

CustomTable.defaultProps = {
  tableHeaderColor: "gray"
};

CustomTable.propTypes = {
  tableHeaderColor: PropTypes.oneOf([
    "warning",
    "primary",
    "danger",
    "success",
    "info",
    "rose",
    "gray"
  ]),
  tableHead: PropTypes.arrayOf(PropTypes.string),
  tableData: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
  // tableSelect: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))
};
